// extracted by mini-css-extract-plugin
export default {"container":"BaseInfoWindow_container__+TLyL","titleIcon":"BaseInfoWindow_titleIcon__Gh6A9","footer":"BaseInfoWindow_footer__XD7Za"};